import Media from './Media';
export default Media;

export { Media };
export MediaOverlay from './MediaOverlay';



// WEBPACK FOOTER //
// ./src/js/Media/index.js